<script setup lang="ts">
import convertToUTC from '@/lib/convertToUTC'

const props = defineProps<{
  event: {
    startAt: string
    endAt: string
  }
}>()

const formattedDate = convertToUTC(props.event.startAt, 'dd.MM.yyyy HH:mm')

const [date, time] = formattedDate.split(' ')
</script>
<template>
  <div
    v-if="date && time"
    class="flex items-center font-medium text-black last:pb-4"
  >
    <p>{{ date }}, {{ time }} {{ $t('time') }}</p>
  </div>
</template>
